import NavBarLinkItem from 'components/navbar-link/NavBarLinkItem';
import { memo } from 'react';

const BossWarehouseSidebarPanel = () => {
  return (
    <div className='sidebar-panel-wrapper !shadow-none border-r border-r-[#E5E9EB] overflow-y-auto h-full'>
      <ul className='sidebar-links-wrapper !shadow-none mt-2 p-3'>
        <NavBarLinkItem
          linkData={{
            path: 'statistic/warehouse/products',
            title: 'Mahsulotlar',
          }}
          iconName='bi bi-box'
          delay={0.1}
        />
        <NavBarLinkItem
          linkData={{
            path: 'statistic/warehouse/incomes',
            title: 'Mahsolutlar kirimi',
          }}
          iconName='bi bi-recycle'
          delay={0.2}
        />
        <NavBarLinkItem
          linkData={{
            path: 'statistic/warehouse/top-rating',
            title: 'Top mahsulotlar',
          }}
          iconName='bi bi-graph-up-arrow'
          delay={0.3}
        />
      </ul>
    </div>
  );
};

export default memo(BossWarehouseSidebarPanel);
